import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CategoryInfo } from '@reflact/ipkv-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoryInfoService {
  private http = inject(HttpClient);
  private baseRoute = '/api/admin/categoryinfo';

  public async list(category: string) {
    return await firstValueFrom(this.http.get<CategoryInfo[]>(this.baseRoute + '/list/' + encodeURIComponent(category)));
  }

  public async listAll() {
    return await firstValueFrom(this.http.get<CategoryInfo[]>(this.baseRoute + '/list'));
  }

  public async get(_id: string) {
    return await firstValueFrom(this.http.get<CategoryInfo>(this.baseRoute + '/get/' + _id));
  }

  public async update(opts: {
    _id: string;
    botIntroductions?: string;
    fallAufgabeIntroductions?: { title: string; content: string }[];
    vcBotIntroductions?: string;
    vcIntroductions?: { title: string; content: string }[];
    FallaufgabeOutro?: string;
    vcOutro?: string;
    vcSampleRate?: number;
  }) {
    return await firstValueFrom(this.http.post<CategoryInfo>(this.baseRoute + '/update', {
      _id: opts._id,
      ...(opts.botIntroductions != null && { botIntroductions: opts.botIntroductions }),
      ...(opts.fallAufgabeIntroductions != null && { fallAufgabeIntroductions: opts.fallAufgabeIntroductions }),
      ...(opts.vcBotIntroductions != null && { vcBotIntroductions: opts.vcBotIntroductions }),
      ...(opts.vcIntroductions != null && { vcIntroductions: opts.vcIntroductions }),
      ...(opts.FallaufgabeOutro != null && { FallaufgabeOutro: opts.FallaufgabeOutro }),
      ...(opts.vcOutro != null && { vcOutro: opts.vcOutro }),
      ...(opts.vcSampleRate != null && { vcSampleRate: opts.vcSampleRate }),
    }));
  }
}
